/** Valores aceitos por `POST /pairing/request` que este player web consegue reconhecer. */
export type DetectedPlayerType = 'webos' | 'tizen' | 'android' | 'web'

/**
 * Plataforma em que o player web está rodando, pelo user agent. Antes o pareamento enviava sempre
 * `webos`, e todo device aparecia como webOS. Navegador comum (desktop, Chrome OS, kiosk) cai em `web`.
 * Ordem importa: o user agent da Tizen e o de alguns webOS também citam Linux, e TVs Android citam Android.
 */
export function detectPlayerType(userAgent: string = globalThis.navigator?.userAgent ?? ''): DetectedPlayerType {
  if (/web0s|webos/i.test(userAgent)) return 'webos'
  if (/tizen/i.test(userAgent)) return 'tizen'
  if (/android/i.test(userAgent)) return 'android'
  return 'web'
}
